import { render, staticRenderFns } from "./PassAudit.vue?vue&type=template&id=7024b906&"
import script from "./PassAudit.vue?vue&type=script&lang=js&"
export * from "./PassAudit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports